import { render, staticRenderFns } from "./ireferralList.vue?vue&type=template&id=8356ce36&"
import script from "./ireferralList.vue?vue&type=script&lang=js&"
export * from "./ireferralList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports